import { IonSearchbar } from "@ionic/react";
import { useDispatch, useSelector } from "react-redux";

import { setSearchText } from "../../../store/templateList";
import { selectSearchText } from "../../../store/templateList/selectors/selectSearchText";

export const TemplateSearchBar = () => {
  const dispatch = useDispatch();
  const searchText = useSelector(selectSearchText);

  return (
    <IonSearchbar
      value={searchText}
      onIonChange={({ detail: { value = "" } }) => {
        dispatch(setSearchText(value));
      }}
      debounce={700}
      placeholder={"Buscar plantilla..."}
    />
  );
};
